import Vue from 'vue'
import Router from 'vue-router'
import browser from 'browser-detect'
import Home from '@/components/Home'
import Cartographie from '@/components/Cartographie'
import Comprendre from '@/components/pages/Comprendre'
import Glossaire from '@/components/pages/Glossaire'
import MentionsLegales from '@/components/pages/MentionsLegales'
import CGU from '@/components/pages/CGU'
import Telechargement from '@/components/pages/Telechargement'

Vue.use(Router)

let firstHomeNav = true
const router = new Router({
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: (to, from, next) => {
      // Accueil mobile (téléphone ou tablette) :
      // redirection vers la carte avec toutes les informations (une fois)
      let redirectToMap = false
      if (browser().mobile && firstHomeNav) {
        firstHomeNav = false
        redirectToMap = true
      }
      next(redirectToMap ? '/cartographie/all' : true)
    }
  }, {
    path: '/cartographie/:mode?',
    name: 'Cartographie',
    component: Cartographie,
    props: true
  }, {
    path: '/cartographie/:mode?/lonlat/:lon/:lat',
    name: 'CartographieLonlat',
    component: Cartographie,
    props: true
  }, {
    path: '/cartographie/mymap/:mapid/:aleat?',
    name: 'CartographieMymap',
    component: Cartographie,
    props: true
  }, {
    path: '/comprendre',
    name: 'Comprendre',
    component: Comprendre
  }, {
    path: '/glossaire',
    name: 'Glossaire',
    component: Glossaire
  }, {
    path: '/mentions-legales',
    name: 'MentionsLegales',
    component: MentionsLegales
  }, {
    path: '/cgu',
    name: 'CGU',
    component: CGU
  }, {
    path: '*',
    redirect: {
      name: 'Home'
    }
  }, {
    path: '/telechargement/:hash',
    name: 'Telechargement',
    component: Telechargement
  }],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // only available for popstate navigations.
      return savedPosition
    }
    if (to.hash) {
      return {
        selector: to.hash
        // , offset: { x: 0, y: 10 }
      }
    }
  }
})

export default router
